import { Icon, IconNames, IconType } from "./Icon";

export { Icon, IconNames };

export type { IconType };
